import { toHex } from '@/utils'
import utils from 'oderon-commons/src/utils'

const delivered = { value: 'Entregue', tagColor: 'green' },
  pending = { value: 'Pendente', tagColor: 'yellow' },
  cancelled = { value: 'Cancelado', tagColor: 'red' }

export default {
  defaultSortable: false,
  defCodes: [],
  columns: [
    { t: 'ID|', d: 'id', color: '#cccccc' },
    { t: 'Veículo', d: 'client.vehicleCode' },
    { t: 'Módulo', d: 'client.id' },

    {
      t: 'Versão|',
      d: 'firmware.version',
      sortBy: false,
      f: (x) => '0x' + toHex(x)
    },
    { t: 'Nome', d: 'firmware.name', f: (x) => utils.atMost(x, 30) },
    {
      t: 'Status',
      sortBy: false,
      d: (row) => {
        if (row.deliveredAt != null) return delivered
        if (row.deletedAt == null) return pending
        return cancelled
      }
    },
    { t: 'Última Pág. Entregue|', d: 'lastDeliveredPage' },
    {
      t: 'Atualizado|',
      d: 'updatedAt',
      sortBy: false,
      dataType: 'date',
      format: 'DD/MMM/YYYY HH:mm'
    }
  ]
}
